import TabPanel from "../Reusable/Tab";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import EditReturnOrder from "./EditReturnOrder";

const SwitchTab = (props: any) => {
  const {
    handleEdit,
    isLoading,
    data,
    handleAttachConsignment,
    handlePrint,
    handleToggleMarkAsDone,
    defaultValue,
    isPrintLoading,
    gridData,
    id,
    handleStatusChange,
    handlecheckConsignments,
    handleAddVehicle,
    isVehicleLoading,
    handleAddDriver,
    isDriverLoading,
    handleCreate,
    isPostLoading,
  } = props;

  return (
    <>
      <>
        <TabPanel
          tabTitle={["Update", "Documents"]}
          tabPanels={[
            <>
              <EditReturnOrder
                handleEdit={handleEdit}
                isLoading={isLoading}
                data={data}
                handleAttachConsignment={handleAttachConsignment}
                handlePrint={handlePrint}
                handleToggleMarkAsDone={handleToggleMarkAsDone}
                defaultValue={defaultValue}
                isPrintLoading={isPrintLoading}
                gridData={gridData}
                handleStatusChange={handleStatusChange}
                handlecheckConsignments={handlecheckConsignments}
                handleAddVehicle={handleAddVehicle}
                isVehicleLoading={isVehicleLoading}
                handleAddDriver={handleAddDriver}
                isDriverLoading={isDriverLoading}
                handleCreate={handleCreate}
                isPostLoading={isPostLoading}
              />
            </>,
            <>
              <FileUpload object_id={id} />
            </>,
          ]}
        />
      </>
    </>
  );
};

export default SwitchTab;
